import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '~/app/store'

function checkSystemTheme() {
  const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)').matches
  return darkThemeMq
}

export type ITheme = 'light' | 'dark' | 'system'
const initialState = {
  theme: (localStorage.getItem('theme')
    ? JSON.parse(localStorage.getItem('theme') as ITheme)
    : 'system') as ITheme
}

const ChangeThemeSlice = createSlice({
  name: 'changeTheme',
  initialState,
  reducers: {
    changeTheme: (state, action: PayloadAction<ITheme>) => {
      state.theme = action.payload
      localStorage.setItem('theme', JSON.stringify(state.theme))
    },
    resetTheme: state => {
      state.theme = 'system'
      localStorage.setItem('theme', JSON.stringify('system'))
    }
  }
})

export const { changeTheme } = ChangeThemeSlice.actions
export const { resetTheme } = ChangeThemeSlice.actions

export const isDarkTheme = (state: RootState) => {
  if (state.theme.theme === 'system') {
    return checkSystemTheme()
  }
  return state.theme.theme === 'dark'
}

export const currentTheme = (state: RootState) => {
  if (state.theme.theme === 'system') {
    return checkSystemTheme() ? 'dark' : 'light'
  }
  return state.theme.theme
}

export const themeState = (state: RootState) => state.theme.theme

export default ChangeThemeSlice.reducer
